var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocuApproved = function SvgDocuApproved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4A69",
    fillRule: "evenodd",
    d: "M28 11.667c-9.02 0-16.333 7.312-16.333 16.333 0 9.02 7.312 16.333 16.333 16.333 9.02 0 16.333-7.312 16.333-16.333 0-9.02-7.312-16.333-16.333-16.333M7 28C7 16.402 16.402 7 28 7s21 9.402 21 21-9.402 21-21 21S7 39.598 7 28m31.983-8.65a2.333 2.333 0 0 1 0 3.3l-14 14a2.333 2.333 0 0 1-3.3 0l-4.666-4.667a2.333 2.333 0 1 1 3.3-3.3l3.016 3.017 12.35-12.35a2.333 2.333 0 0 1 3.3 0",
    clipRule: "evenodd"
  })));
};
export default SvgDocuApproved;